import React from 'react';
import * as Icons from 'lucide-react';
import { trustIndicators } from '../../data/mock';

const TrustStrip = () => {
  return (
    <section className="py-16 bg-[#111111] border-y border-[#D4AF37]/10">
      <div className="container-luxury">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {trustIndicators.map((indicator, index) => {
            const IconComponent = Icons[indicator.icon];
            
            return (
              <div 
                key={index} 
                className="flex items-center space-x-4 group"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="flex-shrink-0 w-12 h-12 bg-[#D4AF37]/10 rounded-lg flex items-center justify-center group-hover:bg-[#D4AF37]/20 transition-colors duration-300">
                  {IconComponent && (
                    <IconComponent className="w-6 h-6 text-[#D4AF37]" />
                  )}
                </div>
                <p className="text-sm font-medium text-[#F6F2E8] leading-snug">
                  {indicator.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustStrip;
